import { lory } from '@rsm/allfarblori';
import h from 'hyperscript';

class InstagramBox {
  constructor($el) {
    this.$el = $el;
    this.$slides = this.$el.querySelectorAll('.instagram-box__slide');

    // Get speed
    const speed = parseInt(this.$el.getAttribute('data-speed') || 2, 10) * 1000;

    // Init lory
    this.lory = lory(this.$el, {
      classNameFrame: 'instagram-box__frame',
      classNameSlideContainer: 'instagram-box__slides',
      enableMouseEvents: false,
      slideSpeed: 350,
      rewind: true,
    });

    // Init dots
    this.$dots = h('.dots.instagram-box__dots');
    this.$slides.forEach((_, index) => {
      const dot = h(`button.dots__dot.instagram-box__dot${index === this.lory.returnIndex() ? '.dots__dot--active.instagram-box__dot--active' : ''}`, {
        type: 'button',
        onclick: () => this.lory.slideTo(index),
      });
      this.$dots.appendChild(dot);
    });
    this.$el.appendChild(h('.instagram-box__dots-wrap', this.$dots));

    // Register events
    this.updateDotsBinded = this.updateDots.bind(this);
    this.$el.addEventListener('after.lory.slide', this.updateDotsBinded);

    // Play event
    this.interval = setInterval(() => this.lory.next(), speed);
  }

  updateDots() {
    // Disable current dot
    this.$dots.querySelector('.dots__dot--active')
      .classList.remove('dots__dot--active', 'instagram-box__dot--active');

    // Enable new dot
    this.$dots.querySelectorAll('.dots__dot')[this.lory.returnIndex()]
      .classList.add('dots__dot--active', 'instagram-box__dot--active');
  }
}

document
  .querySelectorAll('.instagram-box')
  .forEach($el => new InstagramBox($el));
